export default __webpack_public_path__ + "media/images/images/slider/slider-2-8f978359f4f63ee384ee83dfba25767a.png";